export function refreshRemoteContent(element) {
  const remoteEl = element.closest('[data-controller~="load-remote-content"]');
  const remoteController =
    remoteEl &&
    window.Stimulus.getControllerForElementAndIdentifier(remoteEl, "load-remote-content");

  if (remoteController) remoteController.loadRemoteContent();
  else window.location.reload();
}
